import { cn } from "./classNames-DkX30VJU.js";
import { jsx } from "react/jsx-runtime";
// src/blocks/DiagramShared/DiagramSource.tsx
const DiagramSource = ({ code }) => /* @__PURE__ */ jsx("pre", {
	className: cn("tw:my-3 tw:overflow-auto tw:whitespace-pre-wrap tw:break-all", "tw:py-3 tw:px-4", "tw:bg-muted", "tw:rounded-md tw:text-muted-foreground", "tw:text-sm tw:font-mono"),
	children: /* @__PURE__ */ jsx("code", { children: code })
});
// src/blocks/DiagramShared/svgTransforms.ts
const ROOT_SVG_TAG = /^(\s*<svg\b)([^>]*)(>)/i;
const STYLE_ATTR = /\s+style="([^"]*)"/i;
/**
* Makes the root `<svg>` fluid: `width="100%"`, `max-width` from the viewBox, no fixed height.
*
* - Only the root tag: inner icon `<svg>`s keep their fixed size.
* - Keeps `style` (minus `max-width`): Pele's theme vars live there.
* - `extraStyle` declarations follow the existing ones, so they win over the same property.
*/
const makeResponsive = (svgString, extraStyle = "") => {
	const viewBoxMatch = svgString.match(/viewBox="[^"]*\s([\d.]+)\s[\d.]+"/);
	const vbWidth = viewBoxMatch ? Math.round(Number(viewBoxMatch[1])) : void 0;
	return svgString.replace(ROOT_SVG_TAG, (_match, open, attrs, close) => {
		const styleDecls = (attrs.match(STYLE_ATTR)?.[1] ?? "").replace(/max-width:\s*[^;"]*;?\s*/gi, "").replace(/\s+/g, " ").trim().replace(/;$/, "");
		let nextAttrs = attrs.replace(/\s+width="[^"]*"/i, "").replace(/\s+height="[^"]*"/i, "").replace(STYLE_ATTR, "");
		nextAttrs += " width=\"100%\"";
		const styleParts = [
			styleDecls,
			extraStyle,
			vbWidth ? `max-width: ${vbWidth}px` : ""
		].filter(Boolean).join("; ");
		if (styleParts) nextAttrs += ` style="${styleParts}"`;
		return `${open}${nextAttrs}${close}`;
	});
};
export { DiagramSource, makeResponsive };

//# sourceMappingURL=svgTransforms-BBxxO9T6.js.map